<vi-ui-input [value]="filename"
  [disabled]="disabled"
  [label]="label"
  [errorMessage]="errorMessage"
  [maxLength]="MAX_VIDEO_NAME_LENGTH"
  (focusout)="onFocusout($event.target.value)"
  (inputChanged)="onFilenameChanged($event)">